module.exports = __webpack_public_path__ + "img/0Q3B2213_FoamcoreMatted.8f4828a5.jpg";